module.exports = __webpack_public_path__ + "87c693ffef11a9b842690ee0c564281c.pdf";